import type { VisitOptions } from '@inertiajs/core';
import type { RefObject } from 'react';

import { focusFirstError, type FocusFirstErrorOptions } from '@/lib/focus-first-error';

export type WithFocusOnErrorOptions = FocusFirstErrorOptions & {
    containerRef?: RefObject<ParentNode | null>;
};

export function withFocusOnError<T extends VisitOptions>(
    options: T = {} as T,
    focusOptions: WithFocusOnErrorOptions = {},
): T {
    const { containerRef, container, focusDelay, ...restFocusOptions } = focusOptions;
    const existingOnError = options.onError;

    return {
        preserveScroll: true,
        ...options,
        onError: (errors) => {
            focusFirstError(errors, {
                ...restFocusOptions,
                container: container ?? containerRef?.current ?? undefined,
                focusDelay,
            });
            existingOnError?.(errors);
        },
    };
}
